import { useCompleteRequest, useDeclineRequest, useGetRequest } from "../../../api/query_hooks/request";
import ConfirmationModal from "../../../components/dialog/ConfirmationModal";
import Thumbnail from "../../../components/images/thumbnail/Thumbnail";
import { getArtworkImageUrl } from "../../../api/endpoints";
import { Button, Form, Spinner } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import SentOffersPanel from "./SentOffersPanel";
import { useState } from "react";

const CommissionDetails = ({id}) => {

    const requestQuery = useGetRequest(parseInt(id));
    

    return (
        <>
            {requestQuery.isLoading &&
                <div className='bg-dark flex-center gap-2 col-7 h-100 rounded-bottom m-auto'>
                    <Spinner animation="border" role="status" aria-describedby="loading" />
                </div>
            }
            {requestQuery.isError &&
                <div className='bg-dark flex-center gap-2 col-7 h-100 rounded-bottom m-auto'>
                    {requestQuery.error.response?.data}
                </div>
            }
            { requestQuery.isSuccess &&
                <div className='bg-dark d-flex flex-column gap-2 col-7 rounded-bottom'>
                    <CommissionStatusBar id="request-status-bar" request={requestQuery.data?.data} />
                    <CommissionInfoPanel id="request-info-panel" request={requestQuery.data?.data} />
                    {requestQuery.data?.data.status === 'CONFIRMED' &&
                        <SubmissionPanel id="submission-panel" request={requestQuery.data?.data} />
                    }
                    <SentOffersPanel id="offer-panel" request={requestQuery.data?.data} offers={requestQuery.data?.data.offers} />
                </div>
            }
        </>
    );
};

const CommissionStatusBar = ({id="", request}) => {

    const declineRequestMutation = useDeclineRequest();

    const [show, setShow] = useState(false);

    const handleDecline = () => {
        declineRequestMutation.mutate(request?.id);
        setShow(false);
    }


    return (
        <div id={id} className="text-small flex-between px-3 py-1 border-bottom">
            <ConfirmationModal variant="danger" show={show} setShow={setShow} onConfirm={handleDecline} message="Are you sure you want to decline this request?" />

            <div className='d-flex flex-column'>
                <p className='m-0 text-mini user-select-none'>Request ID:</p>
                <p className='m-0'><>&#8226;&nbsp;</> {request?.id}</p>
            </div>
            <div className='d-flex flex-column'>
                <p className='m-0 text-mini user-select-none'>Received on:</p>
                <p className='m-0'>{new Date(request?.createdAt).toLocaleDateString()}</p>
            </div>
            <Button
                variant={request?.status === 'PENDING' ? 'danger' : 'dark'}
                type='button'
                onClick={() => setShow(true)}
                disabled={request?.status !== 'PENDING'}
                className={"py-1 "+(request?.status !== 'PENDING' && 'border border-secondary')}
            >
                Decline request
            </Button>

        </div>
    );
};

const CommissionInfoPanel = ({id="", request}) => {

    const location = useLocation();


    return (
        <div id={id} className="d-flex px-3 gap-2">
            <Link
                to={"/artworks/"+request?.artwork.code}
                state={{back: location.pathname}}
                className="bg-darker hov-bg-1 d-flex col-6 h-100 gap-5 p-2 border border-2 border-black rounded"
            >
                <Thumbnail
                    src={request?.artwork.images?.length ? getArtworkImageUrl(request?.artwork.images[0].path) : process.env.PUBLIC_URL+"/default_artwork.png"}
                    alt={request?.artwork.title}
                    className='col-6'
                />
                <div className='d-flex flex-column gap-2'>
                    <p className='m-0'>{request?.artwork.code}</p>
                    <p className='m-0'>{request?.artwork.title}</p>
                    <p className='m-0'>{request?.artwork.author}</p>
                </div>
            </Link>

            <div className="bg-darker d-flex flex-column flex-grow-1 h-100 border border-2 border-black rounded overflow-y-auto">
                <div className="hov-bg-1 flex-between col-12 px-4 py-2 border-bottom border-2 border-black">
                    <div className="flex-center flex-column align-items-start">
                        <p className='text-end m-0'>{request?.fromUser.username}</p>
                        <p className='text-end m-0'>{request?.fromUser.email}</p>
                    </div>
                    <Thumbnail
                        src={request?.fromUser.propic ? getArtworkImageUrl(request?.fromUser.propic) : process.env.PUBLIC_URL+"/default_propic.png"}
                        className='w-20'
                        roundedCircle={true}
                    />
                </div>
                <div className="hov-bg-1 flex-between flex-grow-1 col-12 px-4 py-2">
                    <div className="d-flex flex-column gap-1">
                        <p className='m-0'>Certificate type:</p>
                        <p className='m-0'>Request status:</p>
                        {request?.offerId && <p className='m-0'>Price:</p>}
                    </div>
                    <div className="d-flex flex-column align-items-end gap-1">
                        <p className='m-0'>{request?.type ? "Evaluation" : "Expertise"}</p>
                        <p className='m-0'>{request?.status}</p>
                        {request?.offerId && <p className='m-0'>{request?.price} €</p>}
                    </div>
                </div>
            </div>
        </div>
    );
};

// return a component called "submissionPanel" consisting in a react bootstrap form with a file input (that only accepts PDFs) and a submit button; it should be flex-row and be as wide as the parent container and only as tall as its content
const SubmissionPanel = ({id="", request}) => {

    const mutation = useCompleteRequest();
    const [file, setFile] = useState(null);

    const submitCertificate = (e) => {
        e.preventDefault();

        const fd = new FormData();
        fd.append('certificate', file);

        mutation.mutate({
            id: request.id,
            body: fd
        });
    }


    return (
        <Form encType="multipart/form-data" id={id} onSubmit={submitCertificate} className="bg-darker d-flex gap-3 mx-3 px-2 py-1 border border-2 border-black rounded">
            <Form.Group className="d-flex flex-row gap-2 flex-grow-1" controlId="submitCertificate">
                <Form.Control name="certificate" type="file" accept="application/pdf" onChange={(e) => {setFile(e.target.files[0])}} size="sm" className="bg-darker border-0" />
            </Form.Group>
            <Button variant="warning" type="submit" className="px-2 py-0" >
                Submit
            </Button>
        </Form>
    );
};


export default CommissionDetails;